import { createPaginator } from "@smithy/core";
import { ListSegmentsCommand, } from "../commands/ListSegmentsCommand";
import { EvidentlyClient } from "../EvidentlyClient";
export const paginateListSegments = createPaginator(EvidentlyClient, ListSegmentsCommand, "nextToken", "nextToken", "maxResults");
